import dayjs from 'dayjs';
import i18n from '@/i18n';

export const LANGUAGE_TO_DAYJS_LOCALE = {
  en: 'en',
  pt: 'pt-br',
};

export function setLocale(language: string | null, locale: string | null) {
  try {
    i18n.changeLanguage(language ? language : 'en');
    dayjs.locale(
      locale ??
        LANGUAGE_TO_DAYJS_LOCALE?.[language as keyof typeof LANGUAGE_TO_DAYJS_LOCALE] ??
        'en'
    );
  } catch (error) {
    console.error('Error setting locale', error);
  }
}
